<template>
  <button @click="prevQuestion" :disabled="currentQuestionIndex === 0"
    class="text-sm flex flex-row text-nowrap items-center justify-center px-4 py-2 bg-slate-900 text-white rounded disabled:opacity-50 duration-300 enabled:hover:bg-slate-800">
    <img src="@/assets/question-arrow-left.svg" class="mr-2" />Önceki soru
  </button>
</template>

<script setup>
import { inject } from "vue";

const prevQuestion = inject("prevQuestion");
const currentQuestionIndex = inject("currentQuestionIndex", 0);
</script>

<style scoped></style>
